/**
 * Footer Component
 * 
 * Displays page navigation controls and current page number.
 */

import React from 'react';
import './Footer.css';

/**
 * Navigation arrow buttons
 */
function NavigationArrow({ direction, onClick, visible }) {
  if (!visible) return <br />;
  
  const iconSrc = direction === 'left' ? './left_arrow.png' : './right_arrow.png';
  const className = direction === 'left' ? 'nav-arrow-left' : 'nav-arrow-right';
  
  return (
    <img
      className={className}
      src={iconSrc}
      alt={direction}
      onClick={onClick}
    />
  );
}

/**
 * Footer with page navigation
 * 
 * @param {object} props - Component props
 * @param {number} props.currentPage - Current page number (1-indexed)
 * @param {number} props.totalPages - Total number of pages
 * @param {boolean} props.canGoNext - Whether next page is available
 * @param {boolean} props.canGoPrevious - Whether previous page is available
 * @param {function} props.onNextPage - Handler for next page button
 * @param {function} props.onPreviousPage - Handler for previous page button
 */
export function Footer({
  currentPage,
  totalPages,
  canGoNext,
  canGoPrevious,
  onNextPage,
  onPreviousPage,
}) {
  return (
    <div className="footer-container">
      <NavigationArrow
        direction="left"
        onClick={onPreviousPage}
        visible={canGoPrevious}
      />
      <p>{currentPage} / {totalPages}</p>
      <NavigationArrow
        direction="right"
        onClick={onNextPage}
        visible={canGoNext}
      />
    </div>
  );
}


